import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SettingsService } from 'src/app/pages/settings/settings.service';
import { AuthService } from 'src/app/services/auth.service';
import { LoadingIndicationService } from 'src/app/services/loading-indication.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { Environment } from 'src/shared/environment-types';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    standalone: false
})
export class AboutComponent implements OnInit {

	// <General>
	private readonly _componentTitle = "About";
	//public htmlCont: string = "";
	public htmlCont: string ="";//= require('src/app/pages/general/about/about/license_info.html');
	// </General>

	protected readonly environment: Environment = environment;

	constructor(
		private _notificationService: NotificationService,
		private _loadingIndicationService: LoadingIndicationService, public authService: AuthService,
		private _titleService: Title, private settingsService: SettingsService

	) { }
	appVersion = "";
	appTitle = "";

	ngOnInit() {
		this._titleService.setTitle(this._componentTitle);

	

		// this.settingsService.SelectPage("AboutUs").subscribe(
		// 	(response) => {
		// 		if (response != null && response.table != null && response.table.length > 0 && response.table[0].data != null) {
		// 			this.htmlCont = response.table[0].data;
		// 		}
		// 		//console.log("initializeColorValues -> getCoreSetting - response:", this.htmlCont);
		// 	},
		// 	(error) => {
		// 		console.error(error);
		// 		this._notificationService.error(error);
		// 	}
		// );
		this.authService.castApplicationVersion.subscribe(select => {
			this.appVersion = select;
		});
		this.authService.castApplicationTitle.subscribe(select => {
			this.appTitle = select;
		});
	}
}
